module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-driver-list row column"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_vm._l((_vm.data), function(line) {
    return [_c('h2', [_vm._v(_vm._s(line.name))]), _c('table', [_vm._m(0, true), _vm._l((line.services), function(service, i) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(++i))]), _c('td', [_vm._v(_vm._s(service.meta.seats_available) + "/" + _vm._s(service.meta.seats_total) + " (" + _vm._s(service.meta.seats_total - service.meta.seats_available) + " passengers)")]), _c('td', [_vm._v(_vm._s(service.departure_time))]), _c('td', [_vm._v(_vm._s(service.arrival_time))]), _c('td', [_vm._v(_vm._s(service.days.join(", ")))])])
    })], 2), _c('hr')]
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('th', [_vm._v("Service")]), _c('th', [_vm._v("Available seats")]), _c('th', [_vm._v("Departure time")]), _c('th', [_vm._v("Arrival time")]), _c('th', [_vm._v("Service days")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-053a5ad8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/TransitList.vue
// module id = 2229
// module chunks = 1